import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import adminDe from '@/locales/admin.de.json';
import adminEn from '@/locales/admin.en.json';
import de from '@/locales/de.json';
import en from '@/locales/en.json';
import opsDe from '@/locales/ops.de.json';
import opsEn from '@/locales/ops.en.json';
import { safeStorage } from './utils';

export const SUPPORTED_LANGUAGES = ['en', 'de'] as const;
export type UiLanguage = (typeof SUPPORTED_LANGUAGES)[number];
const KEY = 'jdap.lang';

function detect(): UiLanguage {
  const stored = safeStorage.get(KEY);
  if (stored === 'en' || stored === 'de') return stored;
  return typeof navigator !== 'undefined' && navigator.language.toLowerCase().startsWith('de') ? 'de' : 'en';
}

void i18n.use(initReactI18next).init({
  // Admin screens (M1-T22) keep their strings in separate files under the `admin` key to avoid merge churn.
  // Ops screens (M1-T21) use the `ops` key the same way.
  resources: {
    en: { translation: { ...en, admin: adminEn, ops: opsEn } },
    de: { translation: { ...de, admin: adminDe, ops: opsDe } },
  },
  lng: detect(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export function setLanguage(lang: UiLanguage): void {
  safeStorage.set(KEY, lang);
  void i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
}

export default i18n;
